<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style  lang='scss'>
#app {
  height: 100%;
  width: 100%;
  position: relative;
  box-sizing: border-box;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue